import { Check } from "lucide-react";

export const PLANS = [
  {
    key: "tools_lifetime",
    name: "Lifetime Access",
    price: "$29",
    cadence: "one-time",
    blurb: "Own the current five tools forever.",
    features: ["All 5 tools available today", "Yours for life — pay once", "Auto-saving worksheets"],
    note: "Future tools not included.",
    highlight: false,
    cta: "Buy lifetime access",
  },
  {
    key: "tools_monthly",
    name: "Membership — Monthly",
    price: "$5",
    cadence: "/month",
    blurb: "Everything, plus every new tool we add.",
    features: ["All 5 tools", "Every future tool, automatically", "Cancel anytime"],
    highlight: false,
    cta: "Start membership",
  },
  {
    key: "tools_yearly",
    name: "Membership — Yearly",
    price: "$45",
    cadence: "/year",
    blurb: "The full library and everything to come.",
    features: ["All 5 tools", "Every future tool, automatically", "Two months free vs. monthly"],
    badge: "Best value",
    highlight: true,
    cta: "Start membership",
  },
];

export const PricingCards = ({ onChoose, busy }) => (
  <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
    {PLANS.map((plan) => (
      <div
        key={plan.key}
        data-testid={`plan-${plan.key}`}
        className={`relative rounded-2xl p-8 flex flex-col ${
          plan.highlight
            ? "bg-wine text-cream border border-wine shadow-xl shadow-wine/20"
            : "bg-white/60 border border-gold/40 text-charcoal"
        }`}
      >
        {plan.badge && (
          <span className="absolute -top-3 left-8 rounded-full bg-terracotta text-cream text-[10px] uppercase tracking-[0.2em] px-3 py-1">
            {plan.badge}
          </span>
        )}
        <h3 className={`font-serif text-xl ${plan.highlight ? "text-cream" : "text-wine"}`}>{plan.name}</h3>
        <div className="mt-4 flex items-baseline gap-1">
          <span className="font-serif text-5xl">{plan.price}</span>
          <span className={`text-sm ${plan.highlight ? "text-cream/70" : "text-charcoal/60"}`}>{plan.cadence}</span>
        </div>
        <p className={`mt-3 text-sm font-light ${plan.highlight ? "text-cream/80" : "text-charcoal/70"}`}>{plan.blurb}</p>
        <ul className="mt-6 space-y-3 flex-1">
          {plan.features.map((f) => (
            <li key={f} className="flex items-start gap-3 text-sm">
              <Check size={16} className={plan.highlight ? "text-blush shrink-0 mt-0.5" : "text-terracotta shrink-0 mt-0.5"} />
              <span className={plan.highlight ? "text-cream/90" : "text-charcoal/80"}>{f}</span>
            </li>
          ))}
        </ul>
        {plan.note && <p className={`mt-4 text-xs italic ${plan.highlight ? "text-cream/60" : "text-charcoal/50"}`}>{plan.note}</p>}
        <button
          onClick={() => onChoose(plan.key)}
          disabled={busy}
          data-testid={`buy-${plan.key}`}
          className={`mt-8 w-full rounded-full px-6 py-3.5 text-sm font-medium tracking-wide transition-colors duration-300 disabled:opacity-60 ${
            plan.highlight ? "bg-cream text-wine hover:bg-blush" : "bg-terracotta text-cream hover:bg-wine"
          }`}
        >
          {busy ? "Please wait…" : plan.cta}
        </button>
      </div>
    ))}
  </div>
);
